@if (attendee&&generalConfig) {
  <div>
    <div class="attendee-form">
      @if (generalConfig.showSalutationField) {
        <label id="salutationLabel" for="salutation">Anrede</label>
        <p-select inputId="salutation" [options]="['Divers','Frau','Herr']" placeholder="Bitte wählen" [(ngModel)]="attendee.salutation" class="fullWidth"> </p-select>
        <div class="w-full mb-2"></div>
      }
      <label id="firstnameLabel" for="firstname">Vorname</label>
      <input id="firstname" type="text" pInputText [(ngModel)]="attendee.firstname">
      <div class="w-full mb-2"></div>
      
      <label id="lastnameLabel" for="lastname">Nachname</label>
      <input id="lastname" type="text" pInputText [(ngModel)]="attendee.lastname">
      <div class="w-full mb-2"></div>
      
      <label id="emailLabel" for="email">E-Mail</label>
      <input id="email" type="text" pInputText [(ngModel)]="attendee.email">
      <div class="w-full mb-2"></div>
    </div>
    @if (attendee.additionalFieldData) {
      <div id="additionalFields">
        @for (field of generalConfig.additionalFields; track field) {
          <div class="attendee-form">
            <label>{{field.label}}</label>
            @if (field.selectableValues.length === 0 && field.type === 'STRING') {
              <input type="text" pInputText [maxLength]="field.lengthLimit" [(ngModel)]="additionalFieldData[field.id].values[0]">
              <div class="w-full mb-2"></div>
            }
            @if (field.selectableValues.length > 0 && field.multiSelect) {
              <div class="attendee-form">
                @for (selectable of field.selectableValues; track selectable; let j = $index) {
                  <div class="flex align-items-center gap-2">
                    <p-checkbox [inputId]="field.id + '_' + j" [name]="field.id" [value]="selectable" [(ngModel)]="additionalFieldData[field.id].values"></p-checkbox>
                    <label [for]="field.id + '_' + j" class="ml-2">{{selectable}}</label>
                  </div>
                }
                @if (field.selectShowOther) {
                  <div>
                    <span style="display: inline-block; vertical-align: middle;">
                      <div class="flex align-items-center gap-2">
                        <p-checkbox inputId="other_{{field.id}}" [name]="field.id" [value]="sentinalNullValue" [(ngModel)]="additionalFieldData[field.id].values"></p-checkbox>
                        <label for="other_{{field.id}}" class="ml-2">Sonstiges:</label>
                      </div>
                    </span>
                    <input type="text" pInputText [disabled]="!additionalFieldData[field.id].hasSentinalValue" [maxLength]="field.lengthLimit" [(ngModel)]="additionalFieldData[field.id].selectOtherField" class="ml-2" style="width: 300px; min-width: 200px;">
                  </div>
                }
                <div class="w-full mb-2"></div>
              </div>
            }
            @if (field.selectableValues.length > 0 && !field.multiSelect) {
              <div class="attendee-form">
                @for (selectable of field.selectableValues; track selectable; let j = $index) {
                  <div class="flex align-items-center gap-2">
                    <p-radioButton [inputId]="field.id + '_' + j" [name]="field.id" [value]="selectable" [(ngModel)]="additionalFieldData[field.id].values[0]"></p-radioButton>
                    <label [for]="field.id + '_' + j" class="ml-2">{{selectable}}</label>
                  </div>
                }
                @if (field.selectShowOther) {
                  <div>
                    <span style="display: inline-block; vertical-align: middle;">
                      <div class="flex align-items-center gap-2">
                        <p-radioButton inputId="other_{{field.id}}" [name]="field.id" [value]="sentinalNullValue" [(ngModel)]="additionalFieldData[field.id].values[0]"></p-radioButton>
                        <label for="other_{{field.id}}" class="ml-2">Sonstiges:</label>
                      </div>
                    </span>
                    <input type="text" pInputText [disabled]="!additionalFieldData[field.id].hasSentinalValue" [maxLength]="field.lengthLimit" [(ngModel)]="additionalFieldData[field.id].selectOtherField" class="ml-2" style="width: 300px; min-width: 200px;">
                  </div>
                }
                <div class="w-full mb-2"></div>
              </div>
            }
            @if (field.type === 'DATE') {
              <input pInputText type="date" [(ngModel)]="additionalFieldData[field.id].values[0]" />
              <div class="w-full mb-2"></div>
            }
            @if (field.type === 'INTEGER') {
              <p-inputNumber [min]="field.minValue" [max]="field.maxValue" [(ngModel)]="additionalFieldData[field.id].values[0]" />
              <div class="w-full mb-2"></div>
            }
            @if (field.type === 'BOOLEAN') {
              <div class="flex align-items-center gap-2">
                <p-checkbox inputId="bool_{{field.id}}" [name]="field.id" [binary]="true" [(ngModel)]="additionalFieldData[field.id].values[0]"></p-checkbox>
                <label for="bool_{{field.id}}" class="ml-2" [innerHTML]="field.checkboxLabel??''"></label>
              </div>
              <div class="w-full mb-2"></div>
            }
          </div>
        }
      </div>
    }
  </div>
}
<div class="card mt-5 pt-2">
  <edu-udo-itmc-dev-mini-book-error-renderer [errors]="errors">
  </edu-udo-itmc-dev-mini-book-error-renderer>
</div>
<div class="flex gap-2 justify-content-end align-items-center p-3">
  <p-button label="Zurück" (click)="back()" ariaLabel="Zurück"></p-button>
  <p-button label="Speichern" (click)="save()" ariaLabel="Speichern"></p-button>
</div>
<div>
  <h3>Stundenplan</h3>
  <edu-udo-itmc-dev-mini-book-timetable-display [entries]="timetableEntries" [showInternalLink]="true">
  </edu-udo-itmc-dev-mini-book-timetable-display>
</div>
<div class="flex gap-2 justify-content-end align-items-center p-3">
  <p-button label="Zurück" (click)="back()" ariaLabel="Zurück"></p-button>
  <p-button label="PDF anzeigen" (click)="openPDF(false)" ariaLabel="PDF anzeigen"></p-button>
  <p-button label="PDF herunterladen" (click)="openPDF(true)" ariaLabel="PDF herunterladen"></p-button>
</div>